


import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { LangProvider } from './i18n/LangContext';

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
